import React from "react";
import ReactHtmlParser from "react-html-parser";
import classnames from "classnames";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import _ from "lodash";

import { formatDate } from "../../../../utils/dates";
import styles from "./Message.scss";

import Button from "../../../../components/common/button/Button";
import Textarea from "../../../../components/common/textarea/Textarea";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import { PROJECT_UPDATE_MESSAGE_FORM } from "../../../../actions/project.actions";

class Message extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFromCurrentUser: false,
      userRole: localStorage.getItem("role")
    };
  }

  componentDidMount() {
    this.setState({
      isFromCurrentUser:
        _.get(this.props.message, "from.email") ===
        localStorage.getItem("userEmail")
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.editSelected !== nextProps.editSelected &&
      nextProps.editSelected &&
      nextProps.editSelected.message
    ) {
      this.props.change("message", nextProps.editSelected.message);
    }
  }

  render() {
    return (
      <div
        className={classnames(styles.messageContainer, {
          [styles.messageContainerRight]: this.state.isFromCurrentUser
        })}
      >
        {!this.props.isEditing
          ? this.renderMessage()
          : this.renderMessageForm()}

        {this.renderFooter()}
      </div>
    );
  }

  renderMessage() {
    const message = this.props.message;
    const action = message.action;
    const project = _.get(this.props.project, "data.data");
    const projectId = _.get(project, "id");

    // The SOW link depends on the role that is seeing the message
    let url;
    let sowUrl;
    let invoiceUrl;

    switch (this.state.userRole) {
      case "admin":
        sowUrl = `/admin/project/${projectId}/sow`;
        invoiceUrl = `/admin/company/${project.employer.profile.company_id}`;
        break;

      case "employer":
        sowUrl = `/company/pitch/${this.props.pitchId}/member/${
          this.props.memberId
        }/project/${projectId}/sow`;
        invoiceUrl = `/company/invoices`;
        break;

      case "member":
        sowUrl = `/member/project/${projectId}/sow`;
        invoiceUrl = `/member/projects/invoices`;
        break;
    }

    if (action) {
      if (action.endsWith("submitted the SOW")) {
        url = sowUrl;
      } else if (action.endsWith("submitted an invoice")) {
        url = invoiceUrl;
      }
    }

    return (
      <React.Fragment>
        <div
          className={classnames(styles.message, {
            [styles.messageRight]: this.state.isFromCurrentUser
          })}
        >
          {this.renderHeader()}

          <div className={styles.messageText}>
            {(url && (
              <Link
                className={styles.link}
                to={url}
                onClick={() => {
                  Mixpanel.track("Project - Messages - Message Link");
                }}
              >
                {ReactHtmlParser(message.message)}
              </Link>
            )) ||
              ReactHtmlParser(message.message)}
          </div>

          {this.renderAttachment()}
        </div>
      </React.Fragment>
    );
  }

  renderMessageForm() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          name="message"
          type="textarea"
          placeholder="Write a message"
          component={Textarea}
          disableCounter={true}
        />

        <div className={styles.editActions}>
          <Button
            isBlue
            label="Cancel"
            onClick={() => this.props.handleEditSelected(null)}
          >
            Cancel
          </Button>

          <Button isBlue type="submit" label="Save Changes">
            Save Changes
          </Button>
        </div>
      </form>
    );
  }

  renderHeader() {
    const action = this.props.message.action;

    const component = (
      <div
        className={classnames(styles.messageHeader, {
          [styles.messageHeaderRight]: this.state.isFromCurrentUser
        })}
      >
        {action}
      </div>
    );

    return action ? component : null;
  }

  renderAttachment() {
    const { id, attachment_name } = this.props.message;

    const component = (
      <div className={styles.messageAttachment}>
        <div className={styles.messageAttachmentContent}>
          <div className={styles.messageAttachmentContentText}>
            Attachment: {attachment_name}
          </div>
          <div
            className={styles.messageAttachmentContentButton}
            onClick={() => this.props.downloadAttachment(id)}
          >
            {this.props.loading ? (
              <Glyphicon glyph="option-horizontal" />
            ) : (
              <Glyphicon glyph="arrow-down" />
            )}
          </div>
        </div>
      </div>
    );

    return attachment_name ? component : null;
  }

  renderFooter() {
    const message = this.props.message;
    const project = _.get(this.props.project, "data.data");

    const user = `${message.from.first_name} ${message.from.last_name}`;
    const isUpdate = message.created_at !== message.updated_at;
    const isSystemAction = message.action !== null;

    const isEditablePitch =
      _.get(project, "status.name") === "pitched" &&
      message.action &&
      message.action.endsWith("pitched this project");

    const footerUser = this.state.isFromCurrentUser
      ? !isUpdate
        ? "You"
        : "You edited"
      : !isUpdate
      ? `${user}`
      : `${user} edited`;

    const footerText = `${footerUser} on ${formatDate(
      !isUpdate ? message.created_at : message.updated_at,
      "MMM DD, YYYY, h:mm a"
    )}`;

    return (
      <div
        className={classnames(styles.messageFooter, {
          [styles.messageFooterRight]: this.state.isFromCurrentUser
        })}
      >
        {!this.props.isEditing && <React.Fragment>{footerText}</React.Fragment>}

        {!this.props.isEditing &&
          this.state.isFromCurrentUser &&
          !isSystemAction && (
            <div>
              <a
                className={styles.editButton}
                onClick={() =>
                  this.props.handleEditSelected(this.props.message)
                }
              >
                <Glyphicon glyph="pencil" className={styles.editButtonIcon} />
                Edit
              </a>
              <a
                className={styles.editButton}
                onClick={() => this.props.handleRemoveOpen(this.props.message)}
              >
                <Glyphicon glyph="trash" className={styles.editButtonIcon} />
                Remove
              </a>
            </div>
          )}

        {this.state.isFromCurrentUser && isEditablePitch && (
          <Link
            to={`/member/projects/matches/pitch-it/${message.pitch.match_id}`}
            className={styles.editButton}
          >
            <Glyphicon glyph="pencil" className={styles.editButtonIcon} />
            Edit
          </Link>
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(
  reduxForm({
    form: `${PROJECT_UPDATE_MESSAGE_FORM}`,
    enableReinitialize: true
  })(Message)
);



// WEBPACK FOOTER //
// ./src/routes/common/messages/Message/Message.js